import tw, { styled } from 'twin.macro'
import { gradientBackground } from '../ColoredBorderWrapper/styled'
import { css } from 'styled-components'

export const HorizontalBreak = styled.hr`
  ${gradientBackground}
  ${tw`border-0 h-0.5`}
`

export const WWW_MDX_OVERRIDE_STYLES = css`
  a {
    ${tw`text-turquoise-500 dark:text-emerald-500`}
  }
`
